<template>
  <div class="animated fadeIn">
    <b-card id="hoverInfo" v-if="showHoverBooking" class="hoverInfo">
      <bookingdetails v-bind:booking="hoverBooking" :readonly="true"></bookingdetails>
    </b-card>
    <b-card>
      <b-card-body>
        <b-button-toolbar aria-label="Toolbar with button groups and input groups">
          <b-input-group class="md-7">
            <b-checkbox @change="toggleFilter()"></b-checkbox>
            <b-button variant="outline" size="sm">Filter:</b-button>           
            <datepicker v-model="dateFilter" @change="updateFilter()" @input="updateFilter()" :stepper="true"
              v-bind:disabled="!enableFilter">
            </datepicker>
          </b-input-group>
          <b-input-group class="md-7" v-if="this.selectedrows.length > 0">
            Urval: {{ this.selectedrows.length }}
            <bookingactionbutton :ids="GetSelectedIds()"></bookingactionbutton>
          </b-input-group>
          <b-input-group>
            <b-button size="sm" variant="light" title="Skapa simuleringsfil" @click="simscriptVisible=true"><b-icon-code-square></b-icon-code-square> Skript</b-button>
          </b-input-group>       
        </b-button-toolbar>
      </b-card-body>
    </b-card>
    <div class="card">
      <div class="card-header">Meddelanden</div>
      <div class="card-body">
        <queryviewlistdetail qvtype="apimessage" ref="blist" :selectable="true" v-on:rowclicked="onclick"
          :hovericons="[{ id: 'ShowInfo', icon: 'info-circle' }]" v-on:iconhover="onhover" v-on:iconunhover="onunhover"
          v-bind:currentkey="currId" v-on:currentkeychanged="oncurrentkeychanged" v-bind:extrafilter="extrafilter"
          v-on:selectionchanged="SelectonChanged" :detailsvisible="myModal" title="Meddelandedetaljer"
          :isBusy="isBusy">
          <template v-slot:details>
            <apimessagedetails :message="work" v-if="work"></apimessagedetails>
          </template>
        </queryviewlistdetail>
      </div>
    </div>
    <b-modal v-model="simscriptVisible" size="xl" ok-only :no-close-on-backdrop="true"
      v-bind:no-close-on-esc="true" :title="Simuleringsskript">
      <simscripteditor></simscripteditor>
    </b-modal>
  </div>
</template>
  
<script>
import queryview from "./../queryview/queryview";
import queryviewlistdetail from "./../queryview/queryviewlistdetail";
import datepicker from "../../components/datepicker";
import apimessagedetails from "./apimessagedetails.vue";
import moment from "moment";
import simscripteditor from "./simscripteditor.vue";
import User from "../../lib/user";
const usr = new User();

import { Api } from "../../lib/api";
//import Bookingactionbutton from './bookingactionbutton.vue';
const api = new Api();

export default {
  name: "bookinglist",
  components: { queryview, queryviewlistdetail, datepicker, apimessagedetails,simscripteditor },
  data() {
    return {
      //id: 0,
      myModal: false,
      work: {},
      hoverBooking: {},
      showHoverBooking: false,
      currId: null,
      extrafilter: null,
      dateFilter: moment(new Date()).format("YYYY-MM-DD"),
      enableFilter: false,
      selectedrows: [],
      fastFindVisible: null,
      currFastFind: null,
      currFilterIds: null,
      filterTermList: null,
      isBusy:false,
      simscriptVisible:false,
    };
  },
  created() {
    this.updateFilter();
    this.isBusy=true;
    api.get("/api/Booking/GetTerminals").then((res) => {
      this.terminals = [];
      this.terminals.push({ terminalId: 0, terminalName: '(ALLA TERMINALER)' });
      this.selTerminal = this.terminals[0];
      res.data.map(x => {
        this.terminals.push(x);
      });
      this.isBusy=false;
    });
  },
  methods: {
    async onclick(row) {
      this.setCurrent(row._key);
    },
    setCurrent(id) {
      this.currId = id;
      this.myModal = true;
      api.get("/api/ApiMessages/" + this.currId).then((res) => {
        this.work = res.data;
        this.myModal = true;

        //Fix to handle resonse parsed as string
        var r = this.work.Resp;
        if (r && r.startsWith('"')) {
          let rObj = JSON.parse(r);
          this.work.Resp = rObj;
        }

      });
    },
    onhover(v) {
      console.log(v);

    },
    onunhover(v) {
      //   console.log("UnHover" + v);
      //   this.hoverBooking = {};
      //   this.showHoverBooking = false;
    },
    // step(s) {
    //   this.$refs.blist.StepCurrent(s);
    // },
    oncurrentkeychanged(row) {
      this.onclick(row);
    },
    isCurrentSelected() {
      var r = this.getCurrentRow();
      if (r) return r.selected;
    },
    getCurrentRow() {
      if (this.currId > 0) return this.$refs.blist.GetRowById(this.currId);
      return null;
    },
    toggleFilter() {
      this.enableFilter = !this.enableFilter;
      this.updateFilter();
    },
    updateFilter() {
      let flt = [];
      if (this.enableFilter && this.dateFilter)
        flt.push({field:'Received',type:'bwn',min:moment(String(this.dateFilter)).format("YYYY-MM-DD"),max:`${moment(String(this.dateFilter)).format("YYYY-MM-DD")} 23:59`});
      this.extrafilter = flt.length>0 ? JSON.stringify(flt) : null;
    },
    onchange(id) {
      this.setCurrent(id);
    },
    SelectonChanged(sel) {
      this.selectedrows = sel;
    },
    GetSelectedIds() {
      return !this.selectedrows ? [] :
        this.selectedrows.map(x => x._key);
    },
    OnActionReady() {
      //Will refresh
      this.setCurrent(this.currId);
    },
    NewBooking() {
      api.post('/api/booking/createnew').then(res => {
        if (res.data > 0) {
          this.setCurrent(res.data);
          return;
        }
        alert('Det gick inte att skapa ny bokning.');
      })
    },
    onfastfindchange(ff) {
      this.currFastFind = ff;
    },
    PerformFastFind() {
      api.post('/api/booking/FastFindSearchFor', this.currFastFind).then((res) => {
        console.log(res.data);
        this.currFilterIds = (res.data.bookingids && res.data.bookingids.length > 0) ? res.data.bookingids : null;
        this.updateFilter();
      });
    },
    IsFastFindFilterActive() {
      return this.currFilterIds && this.currFilterIds.length > 0;
    },
    TermSearchKeyPress(ev) {
      if (ev.key == 'Enter') {
        var qs = this.GetFilteredTermList(this.filterTermList);
        if (qs.length > 0) {
          //this.QvSelect(qs[0].id);
          this.selTerminal = qs[0];
          this.updateFilter();
          this.filterTermList = null;
          this.$refs.termSelectorDropdown.hide(true);
        }
      }
      console.log(ev);
    },
    GetFilteredTermList(filter) {
      if (!this.terminals)
        return [];

      var res = this.terminals;
      if (filter) {
        var flt = filter.toUpperCase();
        res = res.filter(x => x.terminalName.toUpperCase().indexOf(flt) >= 0);
      }
      return res;
    },
    TermSelectorShown(ev) {
      setTimeout(() => {
        this.$refs.termSearchInput.focus();
      }, 500);
    },
  },
};
</script>
  